import ReactGA from "react-ga4";

const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID?.trim();

const isDevEnv = () => {
  const appEnv = (process.env.REACT_APP_ENV || "").toLowerCase();
  return (
    process.env.NODE_ENV === "development" ||
    appEnv === "dev" ||
    appEnv === "development"
  );
};

export const isAnalyticsEnabled = () => Boolean(measurementId) && !isDevEnv();

let initialized = false;

export const initAnalytics = () => {
  if (initialized || !isAnalyticsEnabled()) return;
  ReactGA.initialize(measurementId);
  initialized = true;
};

export const trackPageView = (path) => {
  if (!isAnalyticsEnabled()) return;
  ReactGA.send({
    hitType: "pageview",
    page: path,
    location: window.location.href,
    referrer: document.referrer || undefined,
  });
};

export const trackEvent = ({ category, action, label }) => {
  if (!isAnalyticsEnabled()) return;
  ReactGA.event({ category, action, event_label: label });
};

export const trackButtonClick = (label) => {
  trackEvent({ category: "Button", action: "Click", label });
};
